<template>
    <a-upload
        v-model:file-list="fileList"
        :before-upload="beforeUpload"
        list-type="picture-card"
        :show-upload-list="{ showRemoveIcon: true }"
        :custom-request="dummyRequest"
    >
        <div>
            <PlusOutlined />
        </div>
    </a-upload>
    <a-button
        :disabled="fileList.length === 0 || uploading"
        shape="circle" :icon="h(SaveOutlined)" @click="handleUpload" title="Salvar" />
</template>

<script setup>
import {h, ref} from "vue";
import {message} from "ant-design-vue";
import { PlusOutlined, SaveOutlined} from "@ant-design/icons-vue";

const props = defineProps(['propertyId'])
const emit = defineEmits(['on-upload'])
const fileList = ref([])
const uploading = ref(false)

const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/')
    if (!isImage) {
        message.error('Você só pode fazer upload de imagens!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        message.error('Imagem deve ter menos de 2MB!')
    }
    return isImage && isLt2M
}

const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
        onSuccess('ok')
    }, 0)
}

const handleUpload = async () => {
    uploading.value = true

    try {
        for (const fileItem of fileList.value) {
            const formData = new FormData()
            formData.append('files', fileItem.originFileObj)
            formData.append('matricula', props.propertyId)
            formData.append('type',1)
            await window.axios.post('/photo/upload', formData)
        }
        message.success('Upload concluído com sucesso!')
        fileList.value = []
        emit('on-upload')
    } catch (error) {
        message.error('Erro ao fazer upload.')
        console.error(error)
    } finally {
        uploading.value = false
    }
}
</script>

<style scoped>

:deep(.ant-upload-list-item-container) {
    width: 50px !important;
    height: 50px !important;
}
:deep(.ant-upload-list-item.ant-upload-list-item-done) {
    width: 50px !important;
    height: 50px !important;
}
:deep(.ant-upload) {
    width: 50px !important;
    height: 50px !important;
}


</style>